module.exports = __webpack_public_path__ + "static/HIW4-527bc4973601ddeeb3ea3afddf0ef703.svg";